module.exports = __webpack_public_path__ + "media/images/flags/jm-22fbcf71a6a7feae95bbebf3a819ab94.svg";